<app-common-page-breadcrumbs [navigationData]="navigationData" [pageTitle]="title"></app-common-page-breadcrumbs>
<div class="container py-4 ">
    <div *ngIf="enableLoader" id="loader"></div>
    <p class="text-black bold">{{'home.loginForm.Biometrics.Authmethod' | cxTranslate}}</p>
    <p class="text-black">{{'home.loginForm.Biometrics.UsePasskeyMsg' | cxTranslate}}</p>
    <div *ngIf="!enableLoader">
        <div class="bg-white">
            <div class="d-flex p-3 justify-content-between align-items-center">
                <div><img src="/icons/fingerprint.svg" /></div>
                <div>
                    <p class="text-black bold mb-0">{{'home.loginForm.Biometrics.enable' | cxTranslate}}</p>
                </div>
                <div>
                    <label class="switch">
                        <input [checked]="enableBiometric" type="checkbox" (click)="enableDisablebiometric()">
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>
        </div>
    </div>

</div>